/* LifeSkillsPage — "/life-skills". Landing: title + verbatim meta.intro,
   then the 9-category browser. Purely additive page; dark serif theme. */
import React, { useEffect, useState } from 'react';
import PathwayDisclaimer from '../components/PathwayDisclaimer';
import axios from 'axios';
import { Info } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LifeSkillsBrowser from '../components/lifeskills/LifeSkillsBrowser';

const API = process.env.REACT_APP_BACKEND_URL;
const PARCHMENT = '#F5E9D4';
const DEEP = '#0B1F2E';
const SERIF = '"Fraunces", "Cormorant Garamond", "Georgia", serif';

export default function LifeSkillsPage() {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/lifeskills/meta`).then((r) => setMeta(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: DEEP, minHeight: '100vh' }} data-testid="lifeskills-page">
      <Navbar />
      <header className="max-w-5xl mx-auto px-5 pt-24 pb-8 md:pt-28">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] mb-3" style={{ color: `${PARCHMENT}88` }}>
          Life Skills — For Every Future
        </p>
        <h1
          className="font-serif italic mb-3"
          style={{ color: PARCHMENT, fontFamily: SERIF, fontSize: 'clamp(26px,5vw,44px)', lineHeight: 1.2, letterSpacing: '-0.01em' }}
          data-testid="lifeskills-title"
        >
          Life Skills — For Every Future
        </h1>
        <p className="mb-5 font-medium" style={{ color: `${PARCHMENT}CC`, fontSize: 'clamp(15px,1.8vw,18px)' }} data-testid="lifeskills-subline">
          Practical skills to earn, adapt and grow — for every student, every youth, every future.
        </p>
        {meta?.intro && (
          <p
            className="leading-relaxed whitespace-pre-line"
            style={{ color: `${PARCHMENT}CC`, fontSize: 'clamp(14px,1.6vw,16px)', maxWidth: '75ch' }}
            data-testid="lifeskills-intro"
          >{meta.intro}</p>
        )}
        <p className="flex items-start gap-2 mt-4 text-xs leading-relaxed" style={{ color: `${PARCHMENT}77`, maxWidth: '75ch' }} data-testid="lifeskills-landing-disclaimer">
          <Info size={13} className="mt-0.5 shrink-0" style={{ color: `${PARCHMENT}66` }} />
          {meta?.income_policy || 'All income and risk details are honest indicative guidance, not guarantees — reality varies by place and person.'}
        </p>
      </header>
      <main className="max-w-7xl mx-auto px-5 pb-24">
        <LifeSkillsBrowser />
      </main>
      <PathwayDisclaimer />
      <Footer />
    </div>
  );
}
